module.exports = __webpack_public_path__ + "img/Time.2cad953f.svg";